// extracted by mini-css-extract-plugin
export default {"processing":"Processing_processing__ZNAaK","title":"Processing_title__so0wD","imageBox":"Processing_imageBox__d4DD6","gears":"Processing_gears__7RPIw"};